import { CartContext } from '../../../contexts/CartContext'
import { CartListItem } from './CartListItem/CartListItem'
import { cartTicketCategories } from '../../../utils/cartUtils'
import iconHotel from '../../../images/icons/hotel.svg'
import iconExpress from '../../../images/icons/express.svg'
import Image from "next/legacy/image"
import { format } from 'date-fns'

import { groupCartTicketsByCategoryAndProductAndDate } from '../../../utils/cartUtils'

import styles from './CartList.module.scss'
import { CartRoomItem } from './CartListItem/CartRoomItem/CartRoomItem'

const checkoutPath = '/cart/checkout'

export function CartList() {

  return (
    <CartContext.Consumer>
      {({cartAPI, cart}) => {

        const nextStepButton = cart.meta.count ? <a className={styles.checkoutLinkBottom} href={ checkoutPath }><button className={styles.btn}>CHECKOUT</button></a> : null

        const removeFromCart = (ticketsIds: Array<string>, dateStr?: string) => {
          cartAPI?.removeAll(ticketsIds, dateStr)
        }

        const tickets = groupCartTicketsByCategoryAndProductAndDate(cart.data.tickets)
        const cartListItems: Array<JSX.Element> = []
        const roomTickets = cart.data.tickets.filter(ticket => ticket.tags.includes('rooms'))
        let premier = false;
        let premierHasRun = false;
        let dateFrom = '';
        let dateTo = '';

        cartTicketCategories.forEach(category => {

          if (category === 'rooms' && roomTickets.length > 0) {
            if (roomTickets[0].data.category === 'Premier') {
              premier = true;
              cart.data.tickets.map(ticket => {
                if(ticket.tags.includes('hotels')){
                    dateFrom = ticket.attributes['5'][0];
                    dateTo =ticket.attributes['42'][0];
                }
            })
            }

            const key = roomTickets.map(t => t.cart_item_id).join("-")
            const hotelIcon = <Image alt="hotel-icon" src={iconHotel} width="30" />

            cartListItems.push(
              <CartRoomItem key={key} icon={hotelIcon} rooms={roomTickets} remove={removeFromCart} />
            )

          } else {

            if (Object.getOwnPropertyNames(tickets[category]).length) {

              const byProduct = tickets[category]
              for (const productId in byProduct) {

                for (const date in byProduct[productId]) {

                  const itemTickets = byProduct[productId][date]
                  const key = itemTickets.map(t => t.cart_item_id).join('-')

                  cartListItems.push(
                    <CartListItem key={key} tickets={itemTickets} remove={removeFromCart} />
                  )
                }
              }
            }

            if (premier) {
              if (premierHasRun === false) {
                cartListItems.push(
                  <div key={999} className={styles.cartListItem}>
                    <div className={styles.icon}>
                      <Image alt="express-pass" src={iconExpress} width="30"/>
                    </div>
                    <div className={styles.info}>
                      <h2>FREE Universal Express Unlimited ride access</h2>
                      <div>Universal Studios Florida and Universal Islands of Adventure</div>
                      <div>{format(new Date(dateFrom),'EEE LLL d')} - {format(new Date(dateTo),'EEE LLL d')}</div>
                      {/* { ticketInfo }
                      { searchInfo }
                      { dateInfo }
                      { removeLink } */}
                    </div>
                    <div className={styles.qty}>
                      {/* { qtyPickers } */}
                    </div>
                  </div>
                )
                premierHasRun = true;
              }
            }
          }

        })

        return (
          <>
            <div className={styles.cartList}>
              { cartListItems.length ? cartListItems : "Shopping cart empty" }
            </div>
            { nextStepButton }
          </>
        )
      }}
    </CartContext.Consumer>
  )
}

